import { MenuItem, Select, SelectChangeEvent, Tooltip } from '@mui/material';
import { convertTextToMultiLanguage } from 'common/utils/convert';
import { WeightUnitEnum } from 'interfaces/erms';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const listAreaRelated = [
  WeightUnitEnum.KILOGRAM_PER_ACRE,
  WeightUnitEnum.KILOGRAM_PER_HECTARE,
  WeightUnitEnum.METRIC_TONNE_PER_ACRE,
  WeightUnitEnum.METRIC_TONNE_PER_HECTARE,
];

const listTreeRelated = [WeightUnitEnum.KILOGRAM_PER_TREE, WeightUnitEnum.METRIC_TONNE_PER_TREE];

interface SelectLooseFruitUnitProps {
  looseFruitUnit: WeightUnitEnum;
  setLooseFruitUnit: (arg: WeightUnitEnum) => void;
  area: number;
  totalTree: number;
}

const SelectLooseFruitUnit: FC<SelectLooseFruitUnitProps> = ({
  looseFruitUnit: yieldUnit,
  setLooseFruitUnit: setYieldUnit,
  area,
  totalTree,
}) => {
  const { t } = useTranslation();
  const handleChange = (event: SelectChangeEvent<WeightUnitEnum>) => {
    setYieldUnit(event.target.value as WeightUnitEnum);
  };

  const checkIsDisabled = useCallback(
    (value: WeightUnitEnum) => {
      if (listAreaRelated.includes(value) && !area) return true;
      else if (listTreeRelated.includes(value) && !totalTree) return true;
      return false;
    },
    [area, totalTree]
  );

  const listOptions = Object.values(WeightUnitEnum)
    .filter((item) => item !== WeightUnitEnum.KILOGRAM && item !== WeightUnitEnum.KILOGRAM_PER_BUNCH)
    .map((item) => ({
      value: item,
      label: `${t(convertTextToMultiLanguage(item, 'trans.weight_unit'))}`,
      isDisabled: checkIsDisabled(item),
    }));

  const renderTooltipContent = (value: WeightUnitEnum) => {
    if (listAreaRelated.includes(value) && !area) {
      return 'Please upload boundary file';
    } else if (listTreeRelated.includes(value) && !totalTree) return 'Please upload stand count analytic';
    return '';
  };

  return (
    <Select id="select-yield-unit" size="small" value={yieldUnit} onChange={handleChange}>
      {listOptions.map((item) =>
        item.isDisabled ? (
          <Tooltip key={item.value} title={renderTooltipContent(item.value)}>
            <span>
              <MenuItem key={item.value} value={item.value} disabled={item.isDisabled}>
                {item.label}
              </MenuItem>
            </span>
          </Tooltip>
        ) : (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        )
      )}
    </Select>
  );
};

export default SelectLooseFruitUnit;
